export default __webpack_public_path__ + "media/color/cny-5c3046f0.svg";